import { useEffect, useRef, useContext, useState } from 'react';

import { GlobalContext } from "../../contexts/globalContext";

import NoVideo from '../../graphics/no-video.png';

const CurrentParticipantVideoComponent = () => {

    const { currentParticipantStream, currentConference, currentParticipant, socketRef } = useContext(GlobalContext)

    const videoRef = useRef(null);

    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const playVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                if (currentParticipant?._id !== currentConference.moderatedBy || currentConference.type === "Meeting") {
                    setShowVideo(true);
                } else {
                    setShowVideo(false);
                }
            }
        };

        const pauseVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                setShowVideo(false);
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        return () => {
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);
        }
    }, [])

    useEffect(() => {
        if (currentConference.videoPaused) {
            setShowVideo(false);
        } else {
            setShowVideo(true);
            if (currentConference.type === "Presentation") {
                if (currentParticipant?._id !== currentConference.moderatedBy) {
                    setShowVideo(true);
                } else {
                    setShowVideo(false);
                }

            }

        }
    }, [currentConference])

    useEffect(() => {
        if (showVideo && currentParticipantStream) {
            videoRef.current.srcObject = currentParticipantStream;
        }
    }, [showVideo, currentParticipantStream])

    return (
        <div style={{
            borderRadius: showVideo ? "50%" : "0%",
            width: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id) ? "250px" : "170px",
            height: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id) ? "250px" : "170px",
            display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", marginLeft: "10px", marginTop: "10px", marginBottom: 10,
            position: "relative"
        }}>
            {
                showVideo ? (
                    <video ref={videoRef}
                        poster={NoVideo}
                        height={(currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id) ? "250px" : "180px"}
                        width="auto"
                        autoPlay muted></video>
                ) : (
                    <img style={{ borderRadius: "15px", height: "130px" }} width={170} src={process.env.REACT_APP_CMS_URL + "/assets/flags/" + currentParticipant?.country + ".svg"} />
                )
            }

        </div>
    );
}

export default CurrentParticipantVideoComponent;